import { render, staticRenderFns } from "./coin.vue?vue&type=template&id=7acf9d0d&"
import script from "./coin.vue?vue&type=script&lang=js&"
export * from "./coin.vue?vue&type=script&lang=js&"
import style0 from "./coin.vue?vue&type=style&index=0&id=7acf9d0d&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports